<template>
 <div class="py-1">
        <div class="w-full flex">
           <div class="w-1/2 pt-2 text-lg pl-1">
                Preceptores
           </div>
           <div v-if="canManage" class="w-1/2 flex border-white border-b-4 border-solid justify-end ">
                <button @click="goTo('createStudentAssistant')" class="px-4 py-2 text-gray-200 bg-gray-800 rounded-md hover:bg-gray-700 focus:outline-none focus:bg-gray-700">
                    Agregar Preceptor
                </button>
           </div>
        </div>


        <div  v-if="assistants.length > 0">
            <div class="my-2 overflow-hidden bg-white rounded-md shadow">
                <table class="w-full text-left border-collapse">
                    <thead class="border-b">
                        <tr class="py-5 text-sm font-medium  text-gray-100 bg-indigo-800">
                            <th
                            class="px-5 py-2"
                            >
                            Apellido y Nombre
                            </th>

                            <th class="px-5 py-2">
                                DNI
                            </th>
                            <th class="px-5 py-2">
                                CUIL
                            </th>
                            <th class="px-5 py-2">
                                Teléfono
                            </th>
                            <th class="px-5 py-2">
                                Email
                            </th>

                            <th class="px-5 py-2">
                                Acciones
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                        v-for="(row, index) in assistants"
                        :key="index"
                        class="hover:bg-gray-200 text-sm"
                        >
                        <td class="px-5 py-2  text-gray-700 border-b">
                        {{ row.Profile.lastname }}, {{ row.Profile.firstname }}
                        </td>
                        <td class="px-5 py-2 text-gray-500 border-b">
                        {{ row.Profile.dni }}
                        </td>
                        <td class="px-5 py-3 text-gray-500 border-b">
                            {{ row.Profile.cuil }}
                        </td>
                        <td class="px-5 py-3 text-gray-500 border-b">
                            {{ row.Profile.phone }}
                        </td>

                        <td class="px-5 py-3 text-gray-500 border-b">
                            {{ row.email }}
                        </td>

                        <td class="px-2 py-3 text-left text-gray-500 border-b">
                           <a v-if="canEditRow(row)" href="#" @click.prevent="editUser(row.id)"
                             class="text-indigo-500 hover:text-indigo-800 hover:bg-gray-100 px-3 py-2 rounded-md text-base font-medium">
                            <font-awesome-icon :icon="['fas', 'file-pen']" class="text-prired  mx-0  md::mx-2 text-xl   cursor-pointer hover:text-red-400" />
                           </a>
                        </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'StudentAssistant',
    data(){
        return{
            assistants: []
        }
    },
    computed: {
        ...mapGetters('authentication', ['currentUser']),
        canManage() {
            const r = this.currentUser?.role
            return ['admin', 'administrative', 'executive', 'director'].includes(r)
        },
    },
    created(){
        this.getAssistants()
    },
    methods: {
        canEditRow(row) {
            if (this.canManage) return true
            const uid = this.currentUser?.user_id ?? this.currentUser?.id
            return uid != null && String(row.id) === String(uid)
        },
        editUser(id){
            this.$router.push(`/preceptores/edit/${id}`)
        },
        getAssistants(){
            this.$http.get('/student-assistants')
            .then( res => {
                this.assistants = (res.data.data) ? res.data.data : []
            })
            .catch( err => console.log(err))
        },
        goTo(item){
            if (item === 'createStudentAssistant') {
                this.$router.push(`/preceptores/create`)
            }
        }
    }
}
</script>

<style>

</style>
